import { render } from "./DocList.vue?vue&type=template&id=7aa1d7f4"
import script from "./DocList.vue?vue&type=script&lang=js"
export * from "./DocList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__